import { render } from "./CertificateOzonProducts.vue?vue&type=template&id=f0b4297c"
import script from "./CertificateOzonProducts.vue?vue&type=script&lang=js"
export * from "./CertificateOzonProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__